<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <div class="flex-items">
        <el-select
          v-model="OneCateId"
          placeholder="请选择一级分类"
          @change="onClickSelect"
        >
          <el-option
            v-for="item in List"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
        <el-select
          style="margin-left: 20px"
          v-model="TwoCateId"
          placeholder="请选择二级分类"
          @change="ManageGetTv_VideoInfo"
        >
          <el-option
            v-for="item in TwoList"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="Name"
          style="width: 200px; margin-left: 20px"
          placeholder="请输入内容"
        ></el-input>
        <el-button
          style="margin-left: 20px"
          type="primary"
          @click="ManageGetTv_VideoInfo"
          >查询</el-button
        >
        <el-button style="margin-left: 20px" type="primary" @click="onClickAdd"
          >新增</el-button
        >
      </div>
    </el-card>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="名称" align="center">
      </el-table-column>
      <el-table-column prop="OneCateName" label="一级分类名称" align="center">
      </el-table-column>
      <el-table-column prop="TwoCateName" label="二级分类名称" align="center">
      </el-table-column>
      <el-table-column prop="Url" label="链接地址" align="center">
      </el-table-column>
      <el-table-column prop="Time" label="时长" align="center">
      </el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="onClickEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            style="color: red"
            @click="onClickDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="PageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="PageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="text-align: center;padding:20px; 0 0 0"
    >
    </el-pagination>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="一级分类" prop="parentId">
            <el-select
              v-model="ruleForm.parentId"
              placeholder="请选择一级分类"
              @change="onClickSelect"
            >
              <el-option
                v-for="item in List"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级分类" prop="cateId">
            <el-select v-model="ruleForm.cateId" placeholder="请选择二级分类">
              <el-option
                v-for="item in TwoList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="视频地址" prop="url">
            <div class="flex">
              <el-upload
                :file-list="fileListArr"
                class="image-uploader"
                :auto-upload="true"
                ref="upload"
                :show-file-list="true"
                :drag="true"
                action
                :limit="1"
                accept=".mp4,.qlv,.qsv,.oga,.flv,.avi,.wmv,.rmvb"
                :on-exceed="handleExceed"
                :before-upload="beforeUpload"
                :http-request="afterRead"
                :on-remove="handleRemoveFj"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  一次只能上传一个文件，支持mp4、oga等视频格式
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="视频时长" prop="time">
            <el-input v-model="ruleForm.time" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="ManageAddUpdateTv_VideoInfo('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetCateInfo,
  ManageGetTv_VideoInfo,
  ManageDeleteTv_VideoInfo,
  ManageGetTv_TwoCateInfo,
  ManageAddUpdateTv_VideoInfo,
} from "../../api/api";
import OSS from "ali-oss";

export default {
  data() {
    return {
      TwoCateId: null,
      OneCateId: null,
      List: [],
      TwoList: [],
      Name: "",
      tableData: [],
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      Title: "",
      dialogVisible: false,
      ruleForm: {
        name: "",
        Id: 0,
        time: "",
        url: "",
        parentId: null,
        cateId: null,
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        parentId: [
          { required: true, message: "请选择一级分类", trigger: "change" },
        ],
        url: [{ required: true, message: "请上传视频地址", trigger: "change" }],
        cateId: [
          { required: true, message: "请选择二级分类", trigger: "change" },
        ],
        time: [{ required: true, message: "请输入时长", trigger: "blur" }],
      },
      fileListArr: [],
      dataObj: {
        region: "oss-cn-shanghai", //我的存储是北京，可根据具体配置自行修改
        accessKeyId: "LTAI5tFV2gKH9MHbHip3UUFV",
        accessKeySecret: "bew7cr5TthXrrkQkHauZG10xuqKW8z",
        bucket: "mushroomisand",
      }, //存签名信息
      userInfo: {},
      baseAli: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com", //我的存储是北京，可根据具体配置自行修改
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    await this.GetCateInfo();
    await this.ManageGetTv_VideoInfo();
  },
  watch: {
    dialogVisible(val) {
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
  },
  methods: {
    ResetData() {
      this.ruleForm = {
        name: "",
        Id: 0,
        time: "",
        url: "",
        parentId: null,
        cateId: null,
      };
    },
    async ManageAddUpdateTv_VideoInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await ManageAddUpdateTv_VideoInfo(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.ResetData();
            this.ManageGetTv_VideoInfo();
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      // 文件大小
      let url = URL.createObjectURL(file);
      let audioElement = new Audio(url);
      let duration;
      audioElement.addEventListener("loadedmetadata", (_event) => {
        duration = audioElement.duration; //时长为秒，小数，182.36
        this.ruleForm.time = parseInt(duration);
        console.log(parseInt(duration));
      });
      var maxSize = 2048;
      var size = maxSize * 1024 * 1024;
      if (
        file.type.split("/")[1] == "mp4" ||
        file.type.split("/")[1] == "oga" ||
        file.type.split("/")[1] == "avi"
      ) {
        if (file.size > size) {
          this.$message({
            showClose: true,
            message: `文件过大(不能超过${maxSize}MB)，请重新选择。`,
            type: "error",
          });

          return false;
        }
      } else {
        this.$message({
          showClose: true,
          message: "请选择视频文件",
          type: "error",
        });
        return false;
      }
    },
    formatDate() {
      var value = new Date();
      var year = value.getFullYear();
      var month = formatNum(value.getMonth() + 1);
      var day = formatNum(value.getDate());
      return year + "/" + month + "/" + day;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    //分片上传
    afterRead(file) {
      this.progress = 0;
      var that = this;
      this.progressLoading = true;
      // 此时可以自行将文件上传至服务器
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const filename = file.file.name.substring(0, tmpcnt);
      var value = new Date();
      var year = value.getFullYear();
      var month = this.formatNum(value.getMonth() + 1);
      var day = this.formatNum(value.getDate());

      var time = year + "/" + month + "/" + day + "/";
      let client = new OSS(this.dataObj);

      const progress = (p, _checkpoint) => {
        // Object的上传进度。
        //console.log(p, "p");
        this.progress = Math.round(p * 100, 3);
        // 分片上传的断点信息。
        //console.log(_checkpoint, "_checkpoint");
      };
      // 开始分片上传。
      async function multipartUpload() {
        try {
          console.log(file.file, "file.file");
          //const fileName ="/aaaaaa/" + that.userInfo.uID + "/" + time + file.file.name;
          const fileName =
            "/NewCloud/resource/" +
            that.userInfo.uID +
            "/" +
            time +
            file.file.name;
          console.log(fileName, "fileName");
          // 依次填写Object完整路径（例如exampledir/exampleobject.txt）和本地文件的完整路径（例如D:\\localpath\\examplefile.txt）。Object完整路径中不能包含Bucket名称。
          // 如果本地文件的完整路径中未指定本地路径（例如examplefile.txt），则默认从示例程序所属项目对应本地路径中上传文件。
          const result = await client.multipartUpload(fileName, file.file, {
            progress,
            // 指定meta参数，自定义Object的元信息。通过head接口可以获取到Object的meta数据。
            meta: {
              year: year,
              people: "people",
            },
          });
          console.log(result, "result");
          if (result.res.statusCode == "200") {
            that.loading = false;
            that.fileListArr.push({
              name: filename,
              url: that.baseAli + result.name,
              size: file.file.size,
            });
            that.ruleForm.url = that.baseAli + result.name;
            that.progressLoading = false;
            console.log(that.fileListArr, "  this.fileListArr");
          }
          // // 填写Object完整路径，例如exampledir/exampleobject.txt。Object完整路径中不能包含Bucket名称。
          // const head = await client.head(fileName);
          // console.log(head);
        } catch (e) {
          // 捕获超时异常。
          if (e.code === "ConnectionTimeoutError") {
            console.log("TimeoutError");
            // do ConnectionTimeoutError operation
          }
          console.log(e, "ccc");
        }
      }
      multipartUpload();
    },
    handleRemoveFj(file, fileList) {
      this.fileListArr = fileList;
      this.ruleForm.time = 0;
    },
    onClickAdd() {
      this.Title = "添加";
      this.dialogVisible = true;
    },
    onClickEdit(item) {
      console.log(item);
      this.Title = "修改";
      this.ruleForm = {
        name: item.Name,
        Id: item.Id,
        time: item.Time,
        url: item.Url,
        parentId: item.OneCateId,
        cateId: item.TwoCateId,
      };
      this.fileListArr.push({
        name: item.Name,
        url: item.Url,
        size: 0,
      });
      this.dialogVisible = true;
    },
    onClickDelete(item) {
      this.$confirm("是否删除当前视频, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let xhr = await ManageDeleteTv_VideoInfo({
            ids: [item.Id],
          });
          if (xhr.data.success) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.ManageGetTv_VideoInfo();
          } else {
            this.$message({
              type: "error",
              message: "删除失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async onClickSelect(e) {
      let res = await ManageGetTv_TwoCateInfo({
        Id: e,
      });
      if (res.data.success) {
        this.TwoList = res.data.response;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.ManageGetTv_VideoInfo();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.ManageGetTv_VideoInfo();
    },
    async ManageGetTv_VideoInfo() {
      let res = await ManageGetTv_VideoInfo({
        OneCateId: this.OneCateId ? this.OneCateId : 0,
        TwoCateId: this.TwoCateId ? this.TwoCateId : 0,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.Name,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async GetCateInfo() {
      let res = await GetCateInfo();
      if (res.data.success) {
        this.List = res.data.response;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
  border: 1px solid #c0c4cc;
}
.avatar {
  width: 320px;
  height: 180px;
  display: block;
  object-fit: cover;
}
.avatars {
  width: 95px;
  height: 108px;
  display: block;
}
.avatarlist {
  width: 225px;
  height: 241.5px;
  display: block;
}
.avatar-uploader-iconss {
  padding: 10px 0px;
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  line-height: 30px;
  /* height: 120px; */
  text-align: center;
}
</style>